// src/component/Account/tabs/AccountTab.jsx
import React, { useEffect, useState } from "react";
import { accountService } from "../../../services/accountService";
import { LineSkel } from "../skeletons";
import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";

export default function AccountTab() {
  const { user } = useAuth(); // => { codtiers, ... }
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", address: "" });
  const [msg, setMsg] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!user?.codtiers) return;                // sécurité
      setLoading(true);
      const p = await accountService.getProfile(user.codtiers);
      if (!alive) return;

      setProfile(p);
      setForm({
        name: p?.name || "",
        email: p?.email || "",
        phone: p?.phone || "",
        address: p?.address || "",
      });
      setLoading(false);
    })();

    return () => { alive = false; };
  }, [user?.codtiers]);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

 const onSubmit = async (e) => {
  e.preventDefault();
  if (!user?.codtiers) return;

  setSaving(true);
  setMsg("");

  try {
    const updated = await accountService.updateProfile(user.codtiers, {
      name: form.name,
      email: form.email,
      phone: form.phone,
      address: form.address,
    });

    setProfile((prev) => ({ ...(prev || {}), ...updated }));
    setForm((f) => ({
      ...f,
      name: updated.name ?? f.name,
      email: updated.email ?? f.email,
      address: updated.address ?? f.address,
      phone: updated.phone ?? f.phone,
    }));

    setMsg("Profil mis à jour.");
    toast.success("Profil mis à jour ✓");
  } catch (err) {
    console.log("updateProfile error:", err?.response?.status, err?.response?.data, err?.message);
    const m = err?.response?.data?.message || "Erreur lors de la mise à jour.";
    setMsg(m);
    toast.error(m);
  } finally {
    setSaving(false);
  }
};




  return (
    <section className="acc-panel">
      <h2 className="acc-title">Mes informations</h2>

      {loading ? (
        <div className="acc-form">
          <LineSkel /><LineSkel /><LineSkel /><LineSkel />
        </div>
      ) : (
        <form className="acc-form" onSubmit={onSubmit}>
          <label>Nom complet
            <input name="name" value={form.name} onChange={onChange} required />
          </label>

          <label>Email
            <input name="email" type="email" value={form.email} onChange={onChange} />
          </label>

          <label>Téléphone
            <input name="phone" value={form.phone} onChange={onChange} />
          </label>

          <label>Adresse
            <textarea name="address" value={form.address} onChange={onChange} rows={3} />
          </label>

          {msg && <div className="acc-ok">{msg}</div>}

          <button className="acc-btn" type="submit" disabled={saving}>
            {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
        </form>
      )}
    </section>
  );
}
